import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMediaApi,
  createMediaApi,
  updateMediaApi,
  deleteMediaApi,
} from "./mediaApi";

export const getMedia = createAsyncThunk(
  "media/getMedia",
  async ({ page, limit, search, locationId }, thunkAPI) => {
    try {
      const res = await getMediaApi({ page, limit, search, locationId });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch media"
      );
    }
  }
);

export const createMedia = createAsyncThunk(
  "media/createMedia",
  async (data, thunkAPI) => {
    try {
      const res = await createMediaApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const updateMedia = createAsyncThunk(
  "media/updateMedia",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await updateMediaApi(id, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const deleteMedia = createAsyncThunk(
  "media/deleteMedia",
  async (id, thunkAPI) => {
    try {
      await deleteMediaApi(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const mediaSlice = createSlice({
  name: "media",
  initialState: {
    media: [],
    total: 0,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMedia.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.media = action.payload?.items || [];
        state.total = action.payload?.total || 0;
      })
      .addCase(getMedia.rejected, (state) => {
        state.loading = false;
      })

      .addCase(createMedia.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateMedia.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(deleteMedia.fulfilled, (state, action) => {
        state.media = state.media.filter((m) => m.id !== action.payload);
      });
  },
});

export default mediaSlice.reducer;